import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { formatISO } from 'date-fns';
import RouteTemplate from 'ember-route-template';
import set from 'ember-set-helper/helpers/set';
import VisitorLogTable from 'garaje/components/location-overview/visitor-log/visitor-log-table';
import UiPage from 'garaje/components/ui/page';
import type SkinnyLocationsService from 'garaje/services/skinny-locations';

import type MyLocationsVisitorLogController from './controller';
import type { MyLocationsVisitorLogRouteModel } from './route';

interface MyLocationsVisitorLogTemplateSignature {
  Args: {
    controller: MyLocationsVisitorLogController;
    model: MyLocationsVisitorLogRouteModel;
  };
}

class MyLocationsVisitorLogTemplate extends Component<MyLocationsVisitorLogTemplateSignature> {
  @service declare skinnyLocations: SkinnyLocationsService;

  @action
  setDateRange(start: Date, end: Date): void {
    this.args.controller.startDate = formatISO(start);
    this.args.controller.endDate = formatISO(end);
    this.args.controller.pageNumber = 1;
  }

  @action
  setLocationIds(locationIds?: string): void {
    this.args.controller.locationIds = locationIds;
    this.args.controller.pageNumber = 1;
  }

  @action
  setSignedOut(signedOut?: string): void {
    this.args.controller.signedOut = signedOut;
    this.args.controller.pageNumber = 1;
  }

  @action
  setQuery(query?: string): void {
    this.args.controller.query = query;
    this.args.controller.pageNumber = 1;
  }
  <template>
    <UiPage>
      <VisitorLogTable
        @entries={{@model.entries}}
        @params={{@model.params}}
        @pageNumber={{@controller.pageNumber}}
        @pageSize={{@controller.pageSize}}
        @setPageNumber={{set @controller "pageNumber"}}
        @sortDirection={{@controller.sortDirection}}
        @setSortDirection={{set @controller "sortDirection"}}
        @sortBy={{@controller.sortBy}}
        @setSortBy={{set @controller "sortBy"}}
        @query={{@controller.query}}
        @setQuery={{this.setQuery}}
        @availableLocations={{this.skinnyLocations.readableByLocationAdmin}}
        @locationIds={{@controller.locationIds}}
        @setLocationIds={{this.setLocationIds}}
        @signedOut={{@controller.signedOut}}
        @setSignedOut={{this.setSignedOut}}
        @startDate={{@controller.startDate}}
        @endDate={{@controller.endDate}}
        @setDateRange={{this.setDateRange}}
        @loadingData={{@controller.loadingData}}
      />
    </UiPage>
  </template>
}

export default RouteTemplate(MyLocationsVisitorLogTemplate);
